import React, { useState, useEffect } from 'react'
import { Panel } from 'rsuite'

import SidebarProposal from '../../layouts/sidebarProposal/SidebarProposal'
import PanalLoadingTemplate from '../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../widgets/errorWidget/ErrorWidget'
import { startLoading, doneLoading } from '../../utils/loading'
import ContentHeader from '../../components/ContentHeader/ContentHeader'
import ProjectWaitForWithdrawTableWidget from '../../widgets/admin/ProjectWaitForWithdrawTableWidget'
import WithdrawalPanel from '../../widgets/admin/WithdrawalPanel'
import { getReviewerPaymentInitialPage } from '../../redux/actions/withdrawReviewPayment'

export default function SendWithdrawReview() {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  const [showTableDetail, setShowTableDetail] = useState(true)
  const [isApproveSuccess, setIsApproveSuccess] = useState(false)
  const [projectData, setProjectData] = useState()
  const [isSaveSuccess, setIsSaveSuccess] = useState(false)

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      //const response = await getProjectPaymentReviewById(null, null, 1)
      const response = await getReviewerPaymentInitialPage('', '', 0)
      setSchema(response.model)
    } catch (e) {
      if (e?.response?.data) {
        // console.log('e => ', e?.response?.data)
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errorMessage,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleOnSelectedRowData = async (rowData) => {
    setIsLoading(true)
    startLoading()
    setProjectData()
    try {
      console.log(rowData)
      //get reviewer by project id
      const response = await getReviewerPaymentInitialPage(
        rowData.projectVersionId,
        rowData.projectReviewerPaymentId || null,
        rowData.status
      )

      response.model.forms.projectBudgetPlan.masterBudgetPlan.label = 'แผนงบประมาณ'
      response.model.forms.header =
        rowData?.code + ' ' + rowData?.projectName || response.model.forms.header

      setShowTableDetail(false)
      setProjectData(rowData)
      setSchema(response.model)
      setIsSaveSuccess(false)
    } catch (e) {
      setError({})
      showTableDetail(false)
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleOnCancelShowTable = () => {
    setShowTableDetail(true)
    setProjectData()
    setIsApproveSuccess(false)
    setIsSaveSuccess(false)
  }

  const handleOnSuccess = async (status, projectReviewerPaymentId) => {
    const rowData = {
      ...projectData,
      projectReviewerPaymentId: projectReviewerPaymentId,
      status: status,
    }
    handleOnSelectedRowData(rowData, status)
    setIsSaveSuccess(true)
  }

  if (error) {
    return (
      <SidebarProposal isReviewPayment>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isReviewPayment>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isReviewPayment>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} />

      <Panel header={schema.header} shaded collapsible bordered defaultExpanded>
        <ProjectWaitForWithdrawTableWidget
          onSelectedRowData={handleOnSelectedRowData}
          onShow={showTableDetail}
          onChangeShow={() => setShowTableDetail(!showTableDetail)}
          isApproveSuccess={isApproveSuccess}
          isSaveSuccess={isSaveSuccess}
          statusOptions={schema?.forms?.statusOptions || []}
          statusOptionsForApprover={schema?.forms?.statusOptionsForApprover || []}
        />
        <br />
        {schema.forms && projectData && (
          <WithdrawalPanel
            schema={schema.forms}
            projectData={projectData}
            onCancelShowTable={handleOnCancelShowTable}
            onSuccess={handleOnSuccess}
            isApproveSuccess={() => setIsApproveSuccess(true)}
            onButtonSuccess={()=> handleOnSelectedRowData(projectData)}
          />
        )}
        <br />
      </Panel>
    </SidebarProposal>
  )
}
